(function() {
	'use strict';
	angular.module('widgets.controltower')
		.service('controlTowerService', controlTowerService);

	controlTowerService.$inject = ['$http', 'URLS', 'leanFilterService'];

	function controlTowerService($http, URLS, leanFilterService) {
		var urlPfx = '2/factndx/' + globalConfig.factory.id;
		return {
			getControlTowerData: getControlTowerData,
			getUnaggregatedMetricResults: getUnaggregatedMetricResults,
			getUnaggregatedRawMetricResults: getUnaggregatedRawMetricResults
		};

		function getControlTowerData() {
			var queryParamObject = leanFilterService.getQueryParamsObject(true);
			var timePeriod = queryParamObject['controlTowerTimePeriod'];
			if (!timePeriod) {
				timePeriod = 'Current';
			}
			
			var url = addQueryParam(URLS.controlTowerData,
				leanFilterService.getFactoryList(),
				{
					'vstreams': queryParamObject['valueStream'],
					'categories': queryParamObject['category'],
					'types': queryParamObject['typeName'],
					'timePeriod': timePeriod,
					'metrics': queryParamObject['metric'],
					'multiFactory': queryParamObject['multiFactory'],
					'frequency': queryParamObject['metricFrequency']
				}, false);

			return getData(url);
		}

		function getUnaggregatedMetricResults(filterService, activeOnly) {
			var timePeriod = filterService.getSelected('Control Tower Time Period');
			if (!timePeriod) {
				timePeriod = 'Current';
			}
			var url = addQueryParam(URLS.allMetricResults,
				filterService.getSelected('Factory'),
				{
					'vstreams': filterService.getSelected('Value Stream'),
					'categories': filterService.getSelected('Category'),
					'types': filterService.getSelected('Type'),
					'timePeriod': timePeriod,
					'metrics': filterService.getSelected('Metric'),
					'frequency': filterService.getSelected('Frequency'),
					'activeMetrics': activeOnly
				}, false);

			return getData(url);
		}

		function getUnaggregatedRawMetricResults(factoryIds, metricNdx, qryParams) {
			var url = addQueryParam(URLS.prefix + factoryIds + '/Metric/' + metricNdx +
				'/MetricResultsNonAggregated', null, qryParams);

			return getData(url);
		}

		function getData(url) {
			return $http.get(URLS.host + url)
				.then(getDataComplete)
				.catch(getDataFailed);

			function getDataComplete(response){
				return response.data;
			}

			function getDataFailed(error) {
				return undefined;
			}
		}
	}
})();
